import { StudentData } from "../../scenes/TeacherPortal/types"
import { NOT_SPECIFIED } from "../../constants"

export interface SprintChoiceStats {
    label: string
    studentIds: string[]
}

export interface SprintQuestionStats {
    timedSprintId: string
    exam: string
    subject: string
    sprintNumber: number
    questionNumber: number
    correctAnswer: string
    overall: { choices: SprintChoiceStats[] }
}

export interface TeacherSprintStats {
    totalStudents: number
    questions: SprintQuestionStats[]
}

// Recompute for the selected roster so school and graduation-year filters apply.
export function getQuestionPeriodStats(question: SprintQuestionStats, students: StudentData[]) {
    let ids = new Set(students.map(student => student.id))
    let total = ids.size
    let choices = question.overall.choices.map(choice => {
        let count = new Set(choice.studentIds.filter(id => ids.has(id))).size
        return { label: choice.label, count, percent: total ? count * 100 / total : 0 }
    })
    let correct = choices.find(choice => choice.label === question.correctAnswer)
    let answered = choices.reduce((sum, choice) => sum + choice.count, 0)
    return { choices, accuracy: correct ? correct.percent : 0, correctCount: correct ? correct.count : 0, answeredCount: answered, unanswered: Math.max(0, total - answered) }
}

export function getStudentPeriod(student: StudentData) {
    return student.period || NOT_SPECIFIED
}
